import { render, staticRenderFns } from "./configBar.vue?vue&type=template&id=1e36d7a8&scoped=true&"
import script from "./configBar.vue?vue&type=script&lang=ts&"
export * from "./configBar.vue?vue&type=script&lang=ts&"
import style0 from "./configBar.vue?vue&type=style&index=0&id=1e36d7a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e36d7a8",
  null
  
)

export default component.exports